import { CalendarEventAPIModel, PaginatedAPI } from 'src/app/models/api.model'

export interface CalendarState {
  summary: PaginatedAPI<CalendarEventAPIModel>
  details: CalendarEventAPIModel
}

export const initialCalendarState: CalendarState = {
  summary: undefined,
  details: undefined
}
